import { render } from "./ModalSignOut.vue?vue&type=template&id=8da2bc82&scoped=true"
import script from "./ModalSignOut.vue?vue&type=script&lang=js"
export * from "./ModalSignOut.vue?vue&type=script&lang=js"

import "./ModalSignOut.vue?vue&type=style&index=0&id=8da2bc82&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da2bc82"]])

export default __exports__